import React from "react";
import PropTypes from "prop-types";
import { getString } from "../../utilities";
import { scrollDocVerticallyToTarget } from "../../utilities/scroll";
import OptionallyDisplayed from "../global/optionallyDisplayed";

export default function ManageNav({ isPremiumWeb, isFree, doCancel }) {
  const subText = isFree ? getString("upgrade.title.2") : getString("manage.subscription.title.0");
  const cancelText = isFree ? getString("manage.delete.title.0") : getString("manage.cancel.title.0");

  return (
    <div className="pt-nav">
      <button
        type="button"
        className="button-flat-color"
        onClick={() => {
          scrollDocVerticallyToTarget(document.getElementById("account"));
        }}
      >
        {getString("manage.accountInfo.title.0")}
      </button>

      <OptionallyDisplayed doDisplay={isPremiumWeb}>
        <button
          type="button"
          className="button-flat-color"
          onClick={() => {
            scrollDocVerticallyToTarget(document.getElementById("payment"));
          }}
        >
          {getString("manage.payment.title.0")}
        </button>
      </OptionallyDisplayed>

      <button
        type="button"
        className="button-flat-color"
        onClick={() => {
          scrollDocVerticallyToTarget(document.getElementById("subscription"));
        }}
      >
        {subText}
      </button>

      <OptionallyDisplayed doDisplay={doCancel}>
        <button
          type="button"
          className="button-flat-color"
          onClick={() => {
            scrollDocVerticallyToTarget(document.getElementById("cancel"));
          }}
        >
          {cancelText}
        </button>
      </OptionallyDisplayed>
    </div>
  );
}

ManageNav.propTypes = {
  isPremiumWeb: PropTypes.bool.isRequired,
  isFree: PropTypes.bool.isRequired,
  doCancel: PropTypes.bool.isRequired,
};
